import { render, staticRenderFns } from "./AddSancion.vue?vue&type=template&id=66fa9227"
import script from "./AddSancion.vue?vue&type=script&lang=js"
export * from "./AddSancion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports